export default __webpack_public_path__ + "static/media/Twitter.58b1654b.svg";